import { Box, InlineStack, Strong, Text, Toggle } from '@customerio/pluma-components/react';
import { getVisibleWarehouseOptions, type WarehouseDataOptionTerms } from '@/features/warehouse-sync';
import type { WarehouseDataOptionID } from '@/features/warehouse-sync';
import { LATEST_SCHEMA_VERSION } from '@/services/db/warehouse-sync/entity';
import * as styles from './select-data.css';

export type ExportSelection = Record<WarehouseDataOptionID, boolean>;

type SelectDataProps = {
  selection: ExportSelection;
  isTwilioEnabled: boolean;
  isDisabled: boolean;
  terms: WarehouseDataOptionTerms;
  onChange: (optionId: WarehouseDataOptionID, nextValue: boolean) => void;
};

/**
 * Which exports a new sync will write. New syncs are created at the latest
 * schema, so every option is on offer — `inbound` still needs the Twilio action.
 */
export function SelectData({ selection, isTwilioEnabled, isDisabled, terms, onChange }: SelectDataProps) {
  const options = getVisibleWarehouseOptions({ version: LATEST_SCHEMA_VERSION, isTwilioEnabled, terms });

  return (
    <div className={styles.list}>
      {options.map((option) => (
        <div key={option.id} className={styles.row} data-test-warehouse-select-data-option={option.id}>
          <Box flex={1}>
            <Strong weight="medium">{option.name}</Strong>
            <Text as="div" color="subtle" size="xs">
              {option.description}
            </Text>
          </Box>

          <InlineStack alignBlock="center" ml="200">
            <Toggle
              ariaLabel={option.name}
              isChecked={selection[option.id]}
              onChange={() => onChange(option.id, !selection[option.id])}
              isDisabled={isDisabled}
              size="sm"
            />
          </InlineStack>
        </div>
      ))}
    </div>
  );
}
